import { useSearchFieldStates } from './hooks/useSearchFieldStates';
import { useDynamicSearch } from '@/hooks/use-dynamic-search';
import { ErpDataTableV2 } from '@/components/custom/erp';
import SearchDialog from './components/SearchDialog';
import { invoiceReportColumns } from './columns';
import { useReport, useRows } from '@/hooks';
import { ReportProvider } from './context';
import { ActionBar } from './components';
import { QUERY_KEYS } from '@/constants';
import { useDialogState } from './hooks';

function ReportContent() {
  const { getReport, isLoading, data, currentPage, handlePageChange, totalItems } = useReport({
    endpoint: QUERY_KEYS.BAO_CAO_BAN_HANG_NHOM_THEO_2_CHI_TIEU,
    pageSize: 50
  });
  const searchFieldStates = useSearchFieldStates();

  const {
    initialSearchDialogOpen,
    showTable,
    searchParams,
    handleInitialSearch: handleInitialSearchHook,
    handleRefreshClick: handleRefreshClickHook,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleFixedColumnsClick,
    handleExportDataClick
  } = useDialogState();
  const { handleRowClick, selectedObj, setSelectedObj } = useRows();
  const {
    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isSearching
  } = useDynamicSearch({
    onSearch: getReport,
    params: { ...searchParams, group_by: searchParams.group_by === '0' ? '' : searchParams.group_by },
    onInitialSearch: handleInitialSearchHook,
    getColumns: () => invoiceReportColumns(),
    endpoint: QUERY_KEYS.BAO_CAO_BAN_HANG_NHOM_THEO_2_CHI_TIEU,
    pageSize: 50
  });

  const resolvedRows = hasFilterParams ? searchState.searchResults : data;
  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;
  const resolvedHandlePageChange = hasFilterParams ? handleSearchPageChange : handlePageChange;

  const tables = [
    {
      name: '',
      rows: resolvedRows || [],
      columns: invoiceReportColumns(searchParams.detail_by as number)
    }
  ];

  return (
    <div className='flex h-screen w-screen flex-col lg:overflow-hidden'>
      {initialSearchDialogOpen && (
        <SearchDialog
          onClose={handleInitialSearchClose}
          onSearch={handleInitialSearch}
          initialValues={searchParams}
          searchFieldStates={searchFieldStates}
        />
      )}

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClickHook}
            getReport={getReport}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            fromDate={searchParams.ngay_ct1 || ''}
            toDate={searchParams.ngay_ct2 || ''}
          />

          <div className='w-full overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                totalItems={resolvedTotalItems}
                pageSize={50}
                currentPage={resolvedCurrentPage}
                onPageChange={resolvedHandlePageChange}
                loading={isLoading || isSearching}
                onSearchChange={handleSearchChange}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default function Report() {
  return (
    <ReportProvider>
      <ReportContent />
    </ReportProvider>
  );
}
